import store from "../app/store";
import {createAction} from "@reduxjs/toolkit";
import {
    ACTION_RULES_CHANGED as ACTION_RULES_CHANGED_VALIDATE_PAGE, ACTION_VALIDATE_TABLE_CLEARED,
    ACTION_VALIDATION_RESULT_LIST_CHANGED as ACTION_VALIDATION_RESULT_LIST_CHANGED_VALIDATE_PAGE
} from "./validate/ValidatePageReducer";
import {
    ACTION_RULES_CHANGED as ACTION_RULES_CHANGED_MSB_PAGE
} from "./msb/MsbPageReducer";
import {
    ACTION_MSB_LIST_CHANGED as ACTION_MSB_LIST_CHANGED_ADD_DEVICE_MODAL,
} from "../devices/add-device-modal/AddDeviceModalReducer";
import {getAuthHeader, securedFetch} from "../auth/authService";
import {
    COMPLIANCE_API,
    DEVICE_TYPE_API, EVENT_API, PARAMETER_API, GROUP_API,
    LOCATION_API,
    MSB_API,
    RULE_API,
    SECTOR_API,
    VALIDATE_API,
    VALIDATION_RESULT_API, VALIDATION_WHITELIST_API, VALIDATION_SCHEDULE_API, VIOLATION_RESULT_API
} from "../vars";
import {getSortAndFilterQueryString, getFilterQueryString} from "../view/urlService";
import { ACTION_ANALYSIS_TABLE_CLEARED, ACTION_VALIDATION_RESULT_LIST_CHANGED_ANALYSIS_PAGE
} from "./analysis/AnalysisPageReducer";
import {ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE} from "../recentviolations/RecentViolationsPageReducer";
import {
    ACTION_RULE_CHANGED,
    ACTION_TARGET_TYPES_LOADED
} from "./add-rules/AddRulesPageReducer";
import {showDangerToast, showInfoToast, showSuccessToast} from "../validation/ToastContainer";
import {ACTION_VIOLATIONS_CHANGED} from "../violations/ViolationsPageReducer";
import {ACTION_PARAMETER_CHANGED} from "./parameters/ParametersPageReducer";
import fileSaver from 'file-saver';
import { filterGroupsForCurrentUser } from "../auth/groupAccess";
import * as deviceService from "../devices/deviceService";
// import { notImplemented } from "../utils";

function isCurrentUserAdmin() {
    return String(store.getState().auth?.userRole?.name || "").toLowerCase() === "admin";
}

const targetTypeCache = {};

function getCachedTargetType(key, loader, forceRefresh = false) {
    if (!forceRefresh && targetTypeCache[key]?.data) {
        return Promise.resolve(targetTypeCache[key].data);
    }

    if (!forceRefresh && targetTypeCache[key]?.promise) {
        return targetTypeCache[key].promise;
    }

    const promise = loader()
        .then(data => {
            targetTypeCache[key] = { data };
            return data;
        })
        .catch(error => {
            delete targetTypeCache[key];
            throw error;
        });

    targetTypeCache[key] = { promise };
    return promise;
}

function invalidateTargetTypeCache(keys) {
    keys.forEach(key => delete targetTypeCache[key]);
}

export function msbList() {
    return securedFetch(MSB_API)
        .then(response => response.json());
}

export function copyRuleList(ruleIdList, msbId) {    
    //alert('msbId: ' + msbId)
    //const ruleIdList = ruleIds.map(obj => obj.id);
    return securedFetch(`${RULE_API}/copyrules`, {
        ruleIdList,
        msbId
    }, 'POST').then(response => response.ok);
}

export function moveRuleList(ruleIdList, msbId) {   
    //const ruleIdList = ruleIds.map(obj => obj.id); 
    return securedFetch(`${RULE_API}/moverules`, {
        ruleIdList,
        msbId
    }, 'POST').then(response => response.ok);
}

export function getNonbaseMsbs() {
    return securedFetch(MSB_API)
        .then(response => response.json());
    //alert('copyRulesList')
}

export function deleteRule(id) {    
    return securedFetch(`${RULE_API}/${id}`, null, 'DELETE')
        .then(response => response.ok);
}

export async function removeList(idList) {
    let success = false;    

    for (const ruleId of idList) {
        success = await securedFetch(`${RULE_API}/${ruleId}`, null, 'DELETE').then(res => res.ok);
    }

    return success;
}

export async function enableSystemRemediation(idList) {    
    return await securedFetch(`${RULE_API}/enableremediation`, {
        idList 
    }, 'POST').then(response => response.ok);

}

export function fetchMsbListByDeviceTypeId(id) {
    return securedFetch(`${MSB_API}/device-type?id=${id}`)
        .then(response => response.json());
}

export function msbListByDeviceTypeId(id) {
    return fetchMsbListByDeviceTypeId(id)
        .then(data => {
            store.dispatch(createAction(ACTION_MSB_LIST_CHANGED_ADD_DEVICE_MODAL)({msbList: data}))
            return data;
        });
}

export function remediateRule(deviceId, realTime, ruleId, resultId, currentUser) {
    return securedFetch(`${VALIDATE_API}/remediation?deviceId=${deviceId}&realTime=${realTime}&ruleId=${ruleId}&resultId=${resultId}&currentUser=${currentUser}`, null, 'POST')
        .then(response => response.ok);
}

export function validationResultListRealTimePageable(pageNumber, pageSize) {
    let queryString = getSortAndFilterQueryString(pageNumber, pageSize) + '&f_realTime=1';
    // if (msbId) {
    //     queryString +=`&f_msbPk=${msbId}`
    // }
    //alert (queryString);
    return securedFetch(`${VALIDATION_RESULT_API}/analysispage?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_VALIDATION_RESULT_LIST_CHANGED_ANALYSIS_PAGE)({
                validationResultList: data.page,
                metadata: data.metadata,
                totalRecords: data.records
            }));
                        // store.dispatch(createAction(ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE)({
            //     validationResultList: data.page,
            //     metadata: data.metadata,
            //     totalRecords: data.records
            // }));
            return {devices: data.page, totalPages: data.total, totalRecords: data.records};
        });
}

export function validationResultListRecentViolationPageable(pageNumber, pageSize) {

    let queryString = getSortAndFilterQueryString(pageNumber, pageSize) + '&f_realTime=1';
    return securedFetch(`${VIOLATION_RESULT_API}/recent/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_VALIDATION_RESULT_LIST_CHANGED_RECENT_VIOLATIONS_PAGE)({
                validationResultList: data.page,
                metadata: data.metadata,
                totalRecords: data.records
            }));
            
            return {devices: data.page, totalPages: data.total, totalRecords: data.records}
        })

}

export function getProcessingTasks() {
    return securedFetch(`${VALIDATION_RESULT_API}/processing-tasks`)
        .then(response => response.json());
}

export function  validationResultListNotRealTimePageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize) + '&f_realTime=0';

    return securedFetch(`${VALIDATION_RESULT_API}/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_VALIDATION_RESULT_LIST_CHANGED_VALIDATE_PAGE)({
                validationResultList: data.page,
                metadata: data.metadata,
                totalRecords: data.records
            }))
            return {devices: data.page, totalPages: data.total, totalRecords: data.records}
        })

}

export function violationsList(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${VALIDATION_RESULT_API}/violations/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_VIOLATIONS_CHANGED)({violations: data.page}))
            return {violations: data.page, totalPages: data.total, totalRecords: data.records}
        })

}

export async function loadRuleTargetTypes(options = {}) {
    const {
        includeAllMsbs = false,
        includeAllTargetTypes = false,
        forceRefresh = false,
        skipNavigationFilters = false,
        silentLoading = false
    } = options;
    const canIncludeAllMsbs = includeAllTargetTypes || (includeAllMsbs && isCurrentUserAdmin());
    const requiredCacheKeys = [
        'locations',
        'compliance',
        'sectors',
        'assignedTargetTypes',
        'msbList',
        'groups',
        ...(skipNavigationFilters ? [] : ['scopedRules']),
        ...(canIncludeAllMsbs ? ['deviceTypes'] : [])
    ];
    const hasCachedTargetTypes = !forceRefresh && requiredCacheKeys.every(key => targetTypeCache[key]?.data);

    if (!hasCachedTargetTypes && !silentLoading) {
        store.dispatch(createAction(ACTION_TARGET_TYPES_LOADED)({ targetTypesLoading: true }));
    }

    try {
        const [
            locations,
            compliance,
            sectors,
            assignedTargetTypes,
            allDeviceTypes,
            msbList,
            allGroups,
            scopedRules
        ] = await Promise.all([
            // const locations = await securedFetch(`${LOCATION_API}/nonbase`).then(response => response.json())
            getCachedTargetType('locations', () => securedFetch(LOCATION_API).then(response => response.json()), forceRefresh),
            getCachedTargetType('compliance', () => securedFetch(COMPLIANCE_API).then(response => response.json()), forceRefresh),
            getCachedTargetType('sectors', () => securedFetch(SECTOR_API).then(response => response.json()), forceRefresh),
            getCachedTargetType('assignedTargetTypes', () => deviceService.loadAssignedDeviceTargetTypes(), forceRefresh),
            canIncludeAllMsbs
                ? getCachedTargetType('deviceTypes', () => securedFetch(DEVICE_TYPE_API).then(response => response.json()), forceRefresh)
                : Promise.resolve(null),
            getCachedTargetType('msbList', () => securedFetch(MSB_API).then(response => response.json()), forceRefresh),
            getCachedTargetType('groups', () => securedFetch(GROUP_API).then(response => response.json()), forceRefresh),
            skipNavigationFilters
                ? Promise.resolve([])
                : getCachedTargetType('scopedRules', () => securedFetch(`${RULE_API}/page?p_page=0&p_size=100000`)
                    .then(response => response.json())
                    .then(data => data.page || []), forceRefresh)
        ]);

        const deviceTypes = canIncludeAllMsbs ? allDeviceTypes : assignedTargetTypes.deviceTypes;
        const tags = assignedTargetTypes.tags;
        const groups = includeAllTargetTypes ? allGroups : filterGroupsForCurrentUser(allGroups, store.getState().auth);

        const filterTargetTypesByRules = (targetTypes, relationKey) => {
            const usedTargetTypeIds = new Set();
            scopedRules.forEach(rule => {
                (rule[relationKey] || []).forEach(targetType => {
                    const id = targetType.id || targetType.pk;
                    if (id != null) {
                        usedTargetTypeIds.add(String(id));
                    }
                });
            });

            return (targetTypes || []).filter(targetType =>
                usedTargetTypeIds.has(String(targetType.id || targetType.pk))
            );
        };

        const navigationLocations = skipNavigationFilters ? undefined : filterTargetTypesByRules(locations, 'locations');
        const navigationCompliance = skipNavigationFilters ? undefined : filterTargetTypesByRules(compliance, 'compliance');
        const navigationSectors = skipNavigationFilters ? undefined : filterTargetTypesByRules(sectors, 'sectors');

        const payload = {
            locations,
            compliance,
            sectors,
            navigationLocations,
            navigationCompliance,
            navigationSectors,
            deviceTypes,
            msbList,
            assignedMsbList: assignedTargetTypes.msbList || [],
            groups,
            tags,
            lastRuleLoad: Date.now(),
            targetTypesLoading: false
        };

        store.dispatch(createAction(ACTION_TARGET_TYPES_LOADED)(payload));

        return {
            locations,
            compliance,
            sectors,
            navigationLocations,
            navigationCompliance,
            navigationSectors,
            deviceTypes,
            groups,
            msbList,
            assignedMsbList: assignedTargetTypes.msbList || [],
            tags
        };
    } catch (error) {
        store.dispatch(createAction(ACTION_TARGET_TYPES_LOADED)({ targetTypesLoading: false }));
        throw error;
    }
}

export function ruleListPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${RULE_API}/page?${queryString}`)
        .then(response => response.json())
        .then(data => {
            store.dispatch(createAction(ACTION_RULES_CHANGED_MSB_PAGE)({rules: data.page, totalRecords: data.records}))
            store.dispatch(createAction(ACTION_RULES_CHANGED_VALIDATE_PAGE)({
                rules: data.page,
                totalRecords: data.records
            }))
            return {rules: data.page, pageNumber, totalPages: data.total, totalRecords: data.records}
        })

}

export function getById(id) {  
    return securedFetch(`${RULE_API}?id=${id}`)
        .then(response => response.json())
        .then(rule => {
            store.dispatch(createAction(ACTION_RULE_CHANGED)({rule}))
            return rule;
        })
}

export function getCisRuleInfo(id) {
    return securedFetch(`${RULE_API}/cis-info?id=${id}`)
        .then(response => response?.json?.());
}

export function LoadRuleScriptsNConditions(id) {  
    return securedFetch(`${RULE_API}/scripts?id=${id}`)
        .then(response => response.json());
        
}

export async function saveRule(rule) {    
    const response = await securedFetch(RULE_API, rule, 'POST');
    const success = response.ok;
    const json = await response.json();
    if (success) {
        invalidateTargetTypeCache(['scopedRules']);
        store.dispatch(createAction(ACTION_RULE_CHANGED)({rule: json}))
    }
    // if (success) {
    //     store.dispatch(createAction(ACTION_RULE_CHANGED)({json}))
    // }
    return success;
}


//#region Manage Event
export function saveEvent(event) {
    return securedFetch(EVENT_API, event, 'POST')
        .then(response => response.json());
}

export function changeEvent(event) {
    return securedFetch(`${EVENT_API}/${event.id}`, event, 'POST')
        .then(response => response.json())
}

export function deleteEvent(id) {
    return securedFetch(`${EVENT_API}/${id}`, null, 'DELETE')
        .then(response => response.json());
}
//#endregion


//#region Manage Paramter
//DevTeam - Aug 11, 2022
//The three following functions are developed to manage the parameters
export function saveParameter(parameter) {
    return securedFetch(PARAMETER_API, parameter, 'POST')
        .then(response => response.json());
}

export function changeParameter(parameter) {
    return securedFetch(`${PARAMETER_API}/${parameter.id}`, parameter, 'POST')
        .then(response => response.json())
}

export function deleteParameter(idList) {
    let success = false;    

    for (const id of idList) {
    success = securedFetch(`${PARAMETER_API}/${id}`, null, 'DELETE').then(res => res.ok);
    }

    return success;
}

export function loadParameterList() {
    return securedFetch(PARAMETER_API)
        .then(response => response.json())
        .then((data) => {
            store.dispatch(createAction(ACTION_PARAMETER_CHANGED)({parameters: data}));
            return data;
        });
}
//#endregion


export function startValidation(deviceId, msbId) {
    // alert('ruleService/startValidation')
     return securedFetch(`${VALIDATE_API}?deviceId=${deviceId}&msbId=${msbId}&realTime=0`, null, 'POST')
        .then(response => response.ok);
}

//To recieve a variable response in startValidation
// export function startValidation(deviceId, msbId) {
//     return securedFetch(`${VALIDATE_API}?deviceId=${deviceId}&msbId=${msbId}&realTime=0`, null, 'POST').then(async response => {
//        const res = await response.text();
//        return res;
//     })
// }

export function startValidationList(deviceId, ruleIdList, validationResultPkList, msbId) {
    // alert('ruleService/startValidationList')
    return securedFetch(`${VALIDATE_API}/list/?deviceId=${deviceId}&realTime=0&msbId=${msbId}`, {
        ruleIdList,
        validationResultPkList
    }, 'POST').then(response => response.ok);
}

export function getValidationStatus(deviceId, msbId) {
    return securedFetch(`${VALIDATE_API}?deviceId=${deviceId}&msbId=${msbId}`)
            .then(response => response.ok ? response.json() : {});
}

export function getAnalysisStatus(deviceId) {
    return securedFetch(`${VALIDATE_API}/analysisstatus?deviceId=${deviceId}`)
            .then(response => response.ok ? response.json() : {});
}

export function getLastAnalysisDateTime() {
    const query = getFilterQueryString();   
    return securedFetch(`${VALIDATION_RESULT_API}/analysis/time?${query}`)
        .then(async response => {
            if (response.ok) {
                const text = await response.text();
                return text ? JSON.parse(text) : null;
            }
            return null;
        });
}

export function getLastValidationDateTime() {
    const query = getFilterQueryString();  
    return securedFetch(`${VALIDATION_RESULT_API}/validation/time?${query}`)
        .then(async response => {
            if (response.ok) {
                const text = await response.text();
                return text ? JSON.parse(text) : null;
            }
            return null;
        });
}


// export function acknowledgeValidationResult(idList, realTime) {
//     return securedFetch(`${VALIDATION_WHITELIST_API}/add`, {
//         realTime,
//         validationResultIdList: idList
//     }, 'POST').then(response => response.ok);
// }

export function acknowledgeValidationResult(idList, expiryDate, comment, realTime) {
    return securedFetch(`${VALIDATION_WHITELIST_API}/add?comment=${comment}`, {
        realTime,
        expiryDate,
        validationResultIdList: idList
    }, 'POST').then(response => response.ok);
}

export function removeFromWhitelist(whitelistRecord, realTime) {
    return securedFetch(`${VALIDATION_WHITELIST_API}/remove`, {...whitelistRecord, realTime}, 'POST').then(response => {
        return response && response.ok
    });
}

export function removeRulesFromWhitelist(idList, realTime) {
    return securedFetch(`${VALIDATION_WHITELIST_API}/remove`, {
        realTime,
        validationResultIdList: idList
    }, 'POST').then(response => {
        return response && response.ok
    });
}

// //Original Code bf Base&Custom Rule
// export function saveMsb(msb, deviceType) {
//     return securedFetch(`${MSB_API}`, msb, 'POST').then(response => response && response.json());
// }

//Original Code bf Base&Custom Rule
// export function updateMsb(msb) {
//     return securedFetch(`${MSB_API}`, msb, 'PUT').then(response => response && response.json());
// }



export async function importXlsxRules(file) {
    showInfoToast("Starting rule uploading", "Import Rules", '', true)
    const formData = new FormData();
    formData.append("file", file);
    return fetch(`${RULE_API}/import`,
        {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        }).then(async response => {
            if (!response.ok) {
                showDangerToast('There was an error parsing the rules, please review with support', 'Import Rules');
            }
            const result = await response.text();
            showSuccessToast('Rules Import Statistics: '+result, 'Import Rules');
            return response.ok;
        })
}

//DevTeam: July 07, 2022
//Import Rules from Github Repo in Excel Format
export async function importOnlineRules(){
    showInfoToast("Starting online rules importing", "Import Online Rules", '', true)
    return securedFetch(`${RULE_API}/importOnline`, null, 'POST')
        .then(async response => { 
            if (!response.ok) {
                showDangerToast('There was an error parsing the rules, please review with support', 'Import Rules');
            }
            const result = await response.text();
            showSuccessToast('Rules Import Statistics: '+result, 'Import Online Rules');
            return response.ok;
        })
}

export const clearValidateTable = () => {
    store.dispatch(createAction(ACTION_VALIDATE_TABLE_CLEARED)())
}

export const clearAnalysisTable = () => {
    store.dispatch(createAction(ACTION_ANALYSIS_TABLE_CLEARED)())
}



//#region Manage MSB *Base & Custom Rule Structure*
export function getMsbByName(name) {
    return securedFetch(`${MSB_API}/name`, {name: name}, 'GET').then(response => response && response.json());
}

export async function getMsbByNameIfExists(name) {
    const queryString = new URLSearchParams({ name }).toString();
    const response = await fetch(`${MSB_API}/name?${queryString}`, {
        method: 'GET',
        headers: {
            ...getAuthHeader(),
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        },
        cache: 'no-store'
    });

    if (response.status === 404) {
        return null;
    }

    if (!response.ok) {
        let message = `Request failed with status ${response.status}`;
        try {
            const error = await response.json();
            message = error?.message || error?.error || message;
        } catch (e) {
        }
        throw new Error(message);
    }

    return response.json();
}

export async function saveMsb(msb, deviceType, msbId) {
    return await securedFetch(`${MSB_API}`, {
        msb,
        deviceType,
        msbId
    },'POST')
    .then(response => response && response.json())
    .then(data => {
        invalidateTargetTypeCache(['msbList', 'assignedTargetTypes']);
        return data;
    });
}

export async function copyMsbRules(fromMsbId, toMsbId) {    
    return await securedFetch(`${RULE_API}/copymsbrules`, {
        fromMsbId,
        toMsbId
    }, 'POST').then(response => response.ok);
}

export function updateMsb(msb, deviceType) {
    return securedFetch(`${MSB_API}/${msb.id}`, {
        msb,
        deviceType
    }, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['msbList', 'assignedTargetTypes']);
            return data;
        });
}

export const removeMsbList = async (msbList) => {
    for (const msb of msbList) {
        await securedFetch(`${MSB_API}/${msb.id}`, null, 'DELETE').then(response => response && response.json());
    }
    invalidateTargetTypeCache(['msbList', 'assignedTargetTypes']);
}
//#endregion


//#region Manage Sector
export function getSectorByName(name) {
    return securedFetch(`${SECTOR_API}/name`, {name: name}, 'GET').then(response => response && response.json());
}

export function saveSector(sector) {
    return securedFetch(`${SECTOR_API}`, sector, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['sectors', 'scopedRules']);
            return data;
        });
}

export function updateSector(sector) {
    return securedFetch(`${SECTOR_API}/${sector.id}`, sector, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['sectors', 'scopedRules']);
            return data;
        });
}

export async function removeSectorList(sectorList) {
    const errors = [];
    for (const sector of sectorList) {
        const response = await securedFetch(`${SECTOR_API}/${sector.id}`, null, 'DELETE')
        if (!response.ok) {
            const json = await response.json();
            errors.push(json.message);
        }
    }
    invalidateTargetTypeCache(['sectors', 'scopedRules']);
    return errors;
}
//#endregion


//#region Manage Location
export function getLocationByName(name) {
    return securedFetch(`${LOCATION_API}/name`, {name: name}, 'GET').then(response => response && response.json());
}

export function saveLocation(location) {
    return securedFetch(`${LOCATION_API}`, location, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['locations', 'scopedRules']);
            return data;
        });
}

export function updateLocation(location) {
    return securedFetch(`${LOCATION_API}/${location.id}`, location, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['locations', 'scopedRules']);
            return data;
        });
}

export async function removeLocationList(locationList) {
    const errors = [];
    for (const location of locationList) {
        const response = await securedFetch(`${LOCATION_API}/${location.id}`, null, 'DELETE')
        if (!response.ok) {
            const json = await response.json();
            errors.push(json.message);
        }
    }
    invalidateTargetTypeCache(['locations', 'scopedRules']);
    return errors;
}
//#endregion


//#region Manage Compliance
export function getComplianceByName(name) {
    return securedFetch(`${COMPLIANCE_API}/name`, {name: name}, 'GET').then(response => response && response.json());
}
export function saveCompliance(compliance) {
    return securedFetch(`${COMPLIANCE_API}`, compliance, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['compliance', 'scopedRules']);
            return data;
        });
}

export function updateCompliance(compliance) {
    return securedFetch(`${COMPLIANCE_API}/${compliance.id}`, compliance, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['compliance', 'scopedRules']);
            return data;
        });
}

export async function removeComplianceList(complianceList) {
    const errors = [];
    for (const compliance of complianceList) {
        const response = await securedFetch(`${COMPLIANCE_API}/${compliance.id}`, null, 'DELETE')
        if (!response.ok) {
            const json = await response.json();
            errors.push(json.message);
        }
    }
    invalidateTargetTypeCache(['compliance', 'scopedRules']);
    return errors;
}
//#endregion


//#region Manage DeviceType
export function getDeviceTypeByName(name) {
    return securedFetch(`${DEVICE_TYPE_API}/name`, {name: name}, 'GET').then(response => response && response.json());
}

export function saveDeviceType(deviceType) {
    return securedFetch(`${DEVICE_TYPE_API}`, deviceType, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['deviceTypes', 'assignedTargetTypes']);
            return data;
        });
}

export function updateDeviceType(deviceType) {
    return securedFetch(`${DEVICE_TYPE_API}/${deviceType.id}`, deviceType, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['deviceTypes', 'assignedTargetTypes']);
            return data;
        });
}

export async function removeDeviceTypeList(deviceTypeList) {
    const errors = [];
    for (const deviceType of deviceTypeList) {
        const response = await securedFetch(`${DEVICE_TYPE_API}/${deviceType.id}`, null, 'DELETE');
        if (!response.ok) {
            const json = await response.json();
            errors.push(json.message);
        }
    }
    invalidateTargetTypeCache(['deviceTypes', 'assignedTargetTypes']);
    return errors;
}
//#endregion


//#region Manage Group
export function getGroupByName(name) {
    return securedFetch(`${GROUP_API}/name`, {name: name}, 'GET').then(response => response && response.json());
}

export function saveGroup(group) {
    return securedFetch(`${GROUP_API}`, group, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['groups', 'assignedTargetTypes']);
            return data;
        });
}

export function updateGroup(group) {
    return securedFetch(`${GROUP_API}/${group.id}`, group, 'POST').then(response => response && response.json())
        .then(data => {
            invalidateTargetTypeCache(['groups', 'assignedTargetTypes']);
            return data;
        });
}

export async function removeGroupList(groupList) {
    const errors = [];
    for (const group of groupList) {
        const response = await securedFetch(`${GROUP_API}/${group.id}`, null, 'DELETE')
        if (!response.ok) {
            const json = await response.json();
            errors.push(json.message);
        }
    }
    invalidateTargetTypeCache(['groups', 'assignedTargetTypes']);
    return errors;
}
//#endregion


//Added by Octopus DevTeam June 17-2022:
export function stopValidationList(deviceId) {
    return securedFetch(`${VALIDATE_API}/stop-validation/${deviceId}`,null,'DELETE')
    .then(response => response.ok);
}

//Added by Octopus DevTeam july 6-2022
export async function exportValidationData(pageNumber, pageSize){
    const token = sessionStorage.getItem('access_token');
    let filename="ValidationResults.xlsx";
    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    
    await fetch(`${VALIDATE_API}/export-to-excel?${queryString}`,{
 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        
        body: JSON.stringify({
            filename: filename
        })

    }).then(async (res)=>{
        const responseJson = await res.blob();
        fileSaver.saveAs(responseJson, filename);
    });
    
}

//Added by Octopus DevTeam on july 13-2022
export async function exportAnalysisData(pageNumber, pageSize){
    let filename="AnalysisResults.xlsx";
    const token = sessionStorage.getItem('access_token');
    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    
    await fetch(`${VALIDATION_RESULT_API}/export-to-excel?${queryString}`,{
 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        
        body: JSON.stringify({
            filename: filename
        })

    }).then(async (res)=>{
        const responseJson = await res.blob();
        fileSaver.saveAs(responseJson, filename);
    });
}

//Added by Octopus DevTeam july 18-2022
export async function exportRecentViolationData(pageNumber, pageSize){
    let filename="RecentViolationsResults.xlsx";
    const token = sessionStorage.getItem('access_token');
    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);
     
    await fetch(`${VIOLATION_RESULT_API}/export-to-excel?${queryString}`,{
 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        
        body: JSON.stringify({
            filename: filename
        })

    }).then(async (res)=>{
        const responseJson = await res.blob();
        fileSaver.saveAs(responseJson, filename);
    });
}


// Manage Notes of Results on Validation & Analysis Pages
// export async function addNoteToValidationResult(id, note, notecolor){
//     const params = new URLSearchParams({ id: id, notecolor: notecolor });
//     return await securedFetch(`${VALIDATION_RESULT_API}/save-note?id=${params.toString()}`,
//                                 {note:note}, 'POST')
//         .then((response)=>{
//             if(response.ok){
//                 const rule=response.json();
//                 return rule;
//             }
//         });   
// }
export async function addNoteToValidationResult(id, note, notecolor){
    const body = { id, note, notecolor };

    return await securedFetch(`${VALIDATION_RESULT_API}/save-note`, body, 'POST')
        .then((response)=>{
            if(response.ok){
                const rule=response.json();
                return rule;
            }
        });   
}

export async function deleteValidationResultNote(id){
    return securedFetch(`${VALIDATION_RESULT_API}/delete-note/${id}`, null, 'DELETE')
    .then(async response => {
        const text = await response.text();
        return text.note;
     })
    
}


//#region Manage Validation Schedule
export async function scheduleValidation(validationSchedule){
    return securedFetch(`${VALIDATION_SCHEDULE_API}`, validationSchedule, 'POST' )
    .then(async response =>
        response.json
    )
}

export function getValidationSchedule(userRole) {
    return securedFetch(`${VALIDATION_SCHEDULE_API}?userRole=${userRole}`)
        .then(response => response.ok ? response.json() : {});
}

export function changeValidationActive(updateActive) {
    // return securedFetch(`${VALIDATION_SCHEDULE_API}`, updateActive, 'PUT')
    //     .then(response => response.json());
    const id = updateActive.pk;
    const active = updateActive.active;
    return securedFetch(`${VALIDATION_SCHEDULE_API}/${id}?active=${active}`, null, 'POST')
        .then(response => response.json());    
}

export function deleteSchedule(pk) {
    return securedFetch(`${VALIDATION_SCHEDULE_API}/${pk}`, null, 'DELETE')
        .then(response => response.json());
}
//#endregion



//Added By Octopus DevTeam july 21-2022
// export async function addNoteToRule(ruleId,note){
//     return await securedFetch(`${RULE_API}/add-note?ruleId=${ruleId}`,{note:note}, 'PUT').then((response)=>{
//         if(response.ok){
//             const rule=response.json();
//             return rule;
//         }
//     });
   
// }

// export async function checkRuleNote(rulePk){
  
//     return await fetch(`${RULE_API}/checkRuleNote?ruleId=${rulePk}`,{
 
//         method: 'GET',
//         headers: {
//             //'Content-Type': 'text/plain',
//             'Content-Type':'application/json'
//         }
        
//     }).then(async response => {
//        const text = await response.text();
//        return text;
//     })
       
// }

// export async function deleteRuleNote(rulePk){
//     return securedFetch(`${RULE_API}/delete-rule-note/${rulePk}`, {id:rulePk}, 'DELETE')
//     .then(async response => {
//         const text = await response.text();
//         return text.note;
//      })
    
// }
